"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Yup = __importStar(require("yup"));
var i18n_1 = __importDefault(require("../i18n"));
require("./validators");
var PASSWORD_VALIDATION = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
var resetPasswordSchema = Yup.object({
    email: Yup.string()
        .email(i18n_1.default.t('common:ERROR_MESSAGES.INVALID_EMAIL_ADDRESS'))
        .required(i18n_1.default.t('common:ERROR_MESSAGES.EMAIL_IS_REQUIRED')),
    password: Yup.string()
        .required(i18n_1.default.t('common:ERROR_MESSAGES.PASSWORD_IS_REQUIRED'))
        .matches(PASSWORD_VALIDATION, i18n_1.default.t('common:ERROR_MESSAGES.PASSWORD_NOT_VALID')),
    token: Yup.string(),
});
exports.default = resetPasswordSchema;
